import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { AppState } from '../+store/app.states';
import { of } from 'rxjs';
import { catchError, tap, first, map } from 'rxjs/operators';
import { getIsAuth } from '../+store/auth/auth.selectors';

@Injectable()
export class LoginGuard implements CanActivate {
  constructor(private store: Store<AppState>, public router: Router) { }

  canActivate() {
    return this.store.pipe(
      select(getIsAuth),
      first(),
      map(isAuth => !isAuth),
      catchError(error => {
        console.error(error);
        return of(true);
      })
    );
  }
}
